(() => {
  const ROOT_SELECTOR = '.jdgm-review-widget';
  const LIST_SELECTOR = '.jdgm-review-list';
  const CHANGING_CLASS = 'cv-review-list--changing';
  const ENTER_CLASS = 'cv-review-item--enter';
  const HOME_ROOT_SELECTOR = '.template-index .jdgm-cards-carousel';
  const HOME_CARD_SELECTOR = '.jdgm-media-card';
  const HOME_ACTIVE_CLASS = 'cv-home-review-active';

  const visibleSorts = new Map([
    ['most_helpful', 'おすすめ'],
    ['created_at', '新着順'],
    ['highest_rating', '評価の高い順'],
    ['lowest_rating', '評価の低い順']
  ]);

  const localizeSortOptions = (root) => {
    root.querySelectorAll('.jdgm-sort-dropdown').forEach((select) => {
      const options = new Map([...select.options].map((option) => [option.value, option]));
      [...select.options].forEach((option) => {
        if (!visibleSorts.has(option.value)) option.remove();
      });
      visibleSorts.forEach((label, value) => {
        const option = options.get(value);
        if (option && option.textContent !== label) option.textContent = label;
      });
      const desiredOrder = [...visibleSorts.keys()].filter((value) => options.has(value));
      const currentOrder = [...select.options].map((option) => option.value);
      if (currentOrder.join('|') !== desiredOrder.join('|')) {
        desiredOrder.forEach((value) => select.appendChild(options.get(value)));
      }
    });
  };

  const localizeDates = (root) => {
    root.querySelectorAll('.jm-reviewer-info__details .jm-text').forEach((node) => {
      const match = node.textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (match) node.textContent = `${match[3]}/${match[1]}/${match[2]}`;
    });
  };

  const layoutMasonry = (root) => {
    const list = root?.querySelector(LIST_SELECTOR);
    if (!list) return;
    const items = list.querySelectorAll('.jm-review-item');
    if (window.matchMedia('(max-width: 989px)').matches) {
      items.forEach((item) => item.style.removeProperty('grid-row-end'));
      return;
    }
    items.forEach((item) => item.style.removeProperty('grid-row-end'));
    requestAnimationFrame(() => {
      items.forEach((item) => {
        const span = Math.ceil((item.getBoundingClientRect().height + 16) / 2);
        item.style.gridRowEnd = `span ${span}`;
      });
    });
  };

  const revealList = (list) => {
    window.clearTimeout(list.cvReviewTimer);
    list.cvReviewTimer = window.setTimeout(() => {
      layoutMasonry(list.closest(ROOT_SELECTOR));
      list.classList.remove(CHANGING_CLASS);
      list.querySelectorAll('.jm-review-item').forEach((item) => {
        item.classList.add(ENTER_CLASS);
        requestAnimationFrame(() => requestAnimationFrame(() => item.classList.remove(ENTER_CLASS)));
      });
    }, 140);
  };

  const beginTransition = (root) => {
    const list = root.querySelector(LIST_SELECTOR);
    if (!list) return;
    list.classList.add(CHANGING_CLASS);
    revealList(list);
  };

  const init = (root) => {
    if (root.dataset.cvReviewEnhancement === 'true') return;
    root.dataset.cvReviewEnhancement = 'true';
    localizeSortOptions(root);
    localizeDates(root);
    layoutMasonry(root);
    window.setTimeout(() => layoutMasonry(root), 400);

    root.addEventListener('change', (event) => {
      if (event.target.matches('.jdgm-sort-dropdown')) beginTransition(root);
    }, true);

    const observer = new MutationObserver(() => {
      localizeSortOptions(root);
      localizeDates(root);
      layoutMasonry(root);
      const list = root.querySelector(LIST_SELECTOR);
      if (list?.classList.contains(CHANGING_CLASS)) revealList(list);
    });
    observer.observe(root, { childList: true, subtree: true });

    root.addEventListener('load', (event) => {
      if (event.target instanceof HTMLImageElement) layoutMasonry(root);
    }, true);

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => layoutMasonry(root), 120);
    }, { passive: true });
  };

  const prepareHomepageCards = (root) => {
    const cards = [...root.querySelectorAll(HOME_CARD_SELECTOR)];
    const uniqueReviews = new Set();
    cards.forEach((card) => {
      const reviewId = card.dataset.reviewId;
      const duplicate = reviewId && uniqueReviews.has(reviewId);
      if (reviewId) uniqueReviews.add(reviewId);
      card.classList.toggle('cv-home-review-duplicate', Boolean(duplicate));
    });
    root.dataset.cvReviewCount = String(uniqueReviews.size || cards.length);
    root.classList.toggle('cv-home-review-short', uniqueReviews.size > 0 && uniqueReviews.size <= 4);
    cards.forEach((card) => {
      if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
      card.setAttribute('aria-pressed', card.classList.contains(HOME_ACTIVE_CLASS) ? 'true' : 'false');
    });
  };

  const activateHomepageCard = (root, card) => {
    root.querySelectorAll(HOME_CARD_SELECTOR).forEach((item) => {
      const active = item === card;
      item.classList.toggle(HOME_ACTIVE_CLASS, active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const initHomepageCarousel = (root) => {
    if (root.dataset.cvHomepageReviewEnhancement === 'true') return;
    root.dataset.cvHomepageReviewEnhancement = 'true';
    prepareHomepageCards(root);

    root.addEventListener('click', (event) => {
      const card = event.target.closest(HOME_CARD_SELECTOR);
      if (!card || !root.contains(card) || event.target.closest('button, a')) return;
      if (!card.classList.contains(HOME_ACTIVE_CLASS)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        activateHomepageCard(root, card);
      }
    }, true);

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const card = event.target.closest(HOME_CARD_SELECTOR);
      if (!card || !root.contains(card)) return;
      event.preventDefault();
      activateHomepageCard(root, card);
    });

    new MutationObserver(() => prepareHomepageCards(root)).observe(root, { childList: true, subtree: true });
  };

  const scan = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
    document.querySelectorAll(HOME_ROOT_SELECTOR).forEach(initHomepageCarousel);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
